export const SET_SHARED = 'SET_SHARED';
export const SET_DISABLE_UPDATES = 'TOGGLE_DISABLE_UPDATES';
export const SET_SHOULD_RECENT_REFRESH = 'SET_SHOULD_RECENT_REFRESH';
export const SET_SHOULD_SHARED_REFRESH = 'SET_SHOULD_SHARED_REFRESH';
export const UNSET_SHOULD_REFRESH = 'UNSET_SHOULD_REFRESH';
export const MONITOR_TOGGLE_OVERLAYS = 'MONITOR_TOGGLE_OVERLAYS';
